import PropTypes from "prop-types";
import { noCase } from "change-case";
import React, { useState, useEffect, useContext } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import dayjs from "dayjs";

// @mui
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  TextField,
  Tooltip,
  Divider,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  Select,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  chooseRefreshMyTask,
  chooseActiveCustomerId,
  chooseHeaderCallCustomerId,
  chooseResetToInitVal,
  chooseProjectUserId,
  chooseProjectId,
  chooseProjectName,
} from "../../../Kgo/reducers/reducer";

// utils
import { fToNow } from "../../../utils/formatTime";
import { AuthContext } from "src/Auth/components/AuthContext";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import * as taskService from "src/Definitions/Task/api/api";
import { useDispatch, useSelector } from "react-redux";
// components
import Iconify from "../../../components/Iconify";
import Scrollbar from "../../../components/Scrollbar";
import MenuPopover from "../../../components/MenuPopover";
import { IconButtonAnimate } from "../../../components/animate";
import { toast } from "react-toastify";

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const dispatch = useDispatch();
  const [taskDurum, setTaskDurum] = useState(1);
  const [taskType, setTaskType] = useState(1);

  var dtBas = new Date(Date.now() - 3600 * 37000 * 24);
  var dtBit = new Date(Date.now() + 3600 * 1000 * 24);

  const [baslangicTarihi, setBaslangicTarihi] = useState(dtBas.toISOString());
  //alert(new Date() + "  "+dt)
  const [bitisTarihi, setBitisTarihi] = useState(dtBit.toISOString());

  const refreshMyTask = useSelector((state) => state.reducerKgo.refreshMyTask);

  const { authUser, authStatusReported } = useContext(AuthContext);
  console.log(authUser, "authUser");

  // useEffect(() => {
  //   getTaskList(authUser.userId, null);

  //   return () => {};
  // }, []);

  useEffect(() => {
    getTaskList(authUser.userId, taskDurum,taskType);

    return () => {};
  }, [refreshMyTask]);

  function handleTaskDurumChange(e) {
    setTaskDurum(e.target.value);
    getTaskList(authUser.userId, e.target.value,taskType);
  }
 function handleTaskTypeChange(e) {
    setTaskType(e.target.value);
    getTaskList(authUser.userId,taskDurum, e.target.value);
  }

  function getTaskList(userId, status,tType) {

    // eğer kullanıcı 19 ve 20 rollerinde değilse ,boşuna taskservice apisini çağırmayacak...
   if(authUser.userMenuDefinitionCodes.indexOf(19) >0 || authUser.userMenuDefinitionCodes.indexOf(20) >0 )
   {
    const paramsLst = {
      userId: tType ==2 ? userId : null,
      assignedUserId: tType ==1 ? userId : null,
      customerId: null,
      taskTypeId: 1,
      status: status==2?parseInt( status):null,
      taskStartTime: baslangicTarihi,
      taskEndTime: bitisTarihi,
    };
   
    taskService.list(paramsLst).then((res) => {
      const { isSuccess, message, data: taskList } = res;
      if (isSuccess || message == "Data is empty") {
        setNotifications(taskList);
      } else {
        toast.error(message);
        console.log(res, " taskService.list(paramsLs-hata");
      }
    });
   }
 
  }

  const [gorevListCheckbox, setGorevListCheckbox] = useState(true);

  const [notifications, setNotifications] = useState([]);

  const totalUnRead = notifications.length;

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  function yenileFunc() {
    dispatch(chooseRefreshMyTask(true));
  }
  // const handleChangeGorevListCheckbox = () => {
  //   setGorevListCheckbox((s) => !s);
  //   getMyTasks(authUser.userId, gorevListCheckbox);
  // };

  const handleMarkAllAsRead = () => {
    setNotifications(
      notifications.map((notification) => ({
        ...notification,
        isUnRead: false,
      }))
    );
  };

  return (
    <>
      <IconButtonAnimate
        color={open ? "primary" : "default"}
        onClick={handleOpen}
        sx={{ width: 40, height: 40 }}
      >
        <Badge badgeContent={totalUnRead} color="error">
          <Iconify icon="eva:bell-fill" width={20} height={20} />
        </Badge>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: 360, p: 0, mt: 1.5, ml: 0.75 }}
      >
        <Box sx={{ display: "flex", alignItems: "center", py: 0.5, px: 1.5 }}>
          <Box
            sx={{
              display: "flex",

              alignItems: "flex-start",
              justifyContent: "flex-start",
              flexGrow: 1,
              flexDirection: "column",
            }}
          >
            <Typography component="span" sx={{width:'100%',textAlign:'center'}} variant="subtitle1">
              Görev Takip
            </Typography>

            <DateTimePicker

              renderInput={(props) => <TextField  sx={{m:0.4}} size="small" {...props} />}
              label="Başlangıç"
              value={baslangicTarihi}
              onChange={(newValue) => {
                setBaslangicTarihi(newValue);
                yenileFunc();
              }}
            />

            <DateTimePicker
              renderInput={(props) => <TextField  sx={{m:0.4}}  size="small" {...props} />}
              label="Bitiş"
              value={bitisTarihi}
              onChange={(newValue) => {
                setBitisTarihi(newValue);
                yenileFunc();
              }}
            />

<Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
           width:'100%',
              flexDirection: "row",
              flexGrow:1
            }}
          >
          <Select size="small"
              labelId="Tip"
              id="Tip"
              value={taskType}
              label="Tip"
              onChange={handleTaskTypeChange}
            >
              <MenuItem value="1">Görevlerim</MenuItem>
              <MenuItem value="2">Atamalarım</MenuItem>
            </Select>



            <Select size="small"
              labelId="Durum"
              id="Durum"
              value={taskDurum}
              label="Durum"
              onChange={handleTaskDurumChange}
            >
              {/* <MenuItem value="0">Tümü</MenuItem> */}
              <MenuItem value="1">Tümü</MenuItem>
              <MenuItem value="2">Tamamlanan</MenuItem>
            </Select>

</Box>




            {/* <Typography component="span" variant="body1">
              {gorevListCheckbox ? "Tüm görevler" : "Tüm görevler"}
              <Checkbox
                checked={gorevListCheckbox}
                onChange={() => handleChangeGorevListCheckbox()}
              />
            </Typography> */}
          </Box>

          {/* {totalUnRead > 0 && (
            <Tooltip title=" Mark all as read">
              <IconButtonAnimate color="primary" onClick={handleMarkAllAsRead}>
                <Iconify icon="eva:done-all-fill" width={20} height={20} />
              </IconButtonAnimate>
            </Tooltip>
          )} */}
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Scrollbar sx={{ height: { xl: 500, l: 500, xs: 340, sm: "auto" } }}>
          <List>
            {notifications.map((notification) => (

              // (taskDurum==1 && notification.status!=2) || taskDurum==2 ?
              <NotificationItem
                key={notification.id}
                notification={notification}
              />


            ))}
          </List>
        </Scrollbar>

        <Divider sx={{ borderStyle: "dashed" }} />

        {/* <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple>
            View All
          </Button>
        </Box> */}
      </MenuPopover>
    </>
  );
}

// ----------------------------------------------------------------------

// NotificationItem.propTypes = {
//   notification: PropTypes.shape({

//     id: PropTypes.string,
//     isUnRead: PropTypes.bool,
//     title: PropTypes.string,
//     description: PropTypes.string,
//     type: PropTypes.string,
//     avatar: PropTypes.any,
//   }),
// };

function NotificationItem({ notification }) {
  const { pathname } = useLocation();
  let navigate = useNavigate();

  const dispatch = useDispatch();

  const datapageYonlendir = (notification, pathname) => {
    const { projectId, userId, customerId, projectName } = notification;

    // console.log(projectId,userId,customerId,notification,"yonelndir");

    const paramsLst = {
      projectId: projectId,
      userId: userId,
    };
    taskService.getProjectUsers(paramsLst).then((res) => {
      const { isSuccess, message, data: projectUserData } = res;
      if (isSuccess || message == "Data is empty") {
        console.log(projectUserData, "projaskdjlsadjfkljdsfl");
        const p = projectUserData[0];
        if (pathname == "/dashboard/datapage") {
          //TODO
          //projectUserId vs

          //dispatch( chooseResetToInitVal());
          // dispatch( chooseHeaderCallCustomerId(customerId));
          // dispatch( chooseProjectUserId(p.id));

          // dispatch(  chooseProjectUserId(p.id));

          // dispatch( chooseHeaderCallCustomerId(customerId));

          dispatch(chooseProjectUserId(p.id));
          dispatch(chooseProjectId(projectId));
          dispatch(chooseProjectName(projectName));
          //dispatch(  chooseSelectedFair(location?.state?.fairId));//projenin fuar iliskisi varsa

          dispatch(chooseActiveCustomerId(customerId));
        } else
          navigate("/dashboard/datapage", {
            state: {
              projectUserId: p.id,
              projectId: p.projectId,
              name: projectName,
              fairId: 0,
              customerId: customerId,
              triggerFrom: "Tasks",
            },
            replace: true,
          });
      } else {
        toast.error(message);
        console.log(res, " taskService.list(paramsLs-hata");
      }
    });
  };

  function yenileFunc() {
    dispatch(chooseRefreshMyTask(true));
  }
  const { avatar, title, projectName, atayan ,atanan} = renderContent(
    notification,
    yenileFunc
  );

  return (
    <ListItemButton
      onClick={() => datapageYonlendir(notification, pathname)}
      sx={{
        py: 1.5,
        px: 2.5,
        mt: "1px",
        ...(true && {
          bgcolor: "action.selected",
        }),
      }}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: "background.neutral" }}>{avatar}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: "flex",
              alignItems: "center",
              color: "text.disabled",
            }}
          >
            <Iconify
              icon="eva:clock-outline"
              sx={{ mr: 0.5, width: 16, height: 16 }}
            />
            {atayan} tarafından {atanan} adlı kişiye
            {/* {fToNow(notification.createdAt)} */}
          </Typography>
        }
      />
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function renderContent(notification, yenileFunc) {
  const handleChangeTask = (id, note) => {
    const paramsLst = {
      id: id,
      note: note,
      status: true,
    };
    taskService.update(paramsLst).then((res) => {
      const { isSuccess, message, data: taskList } = res;
      if (isSuccess || message == "Data is empty") {
        toast.success("Görev tamamlandı.");
        yenileFunc();
      } else {
        toast.error(message);
        console.log(res, " taskService.update(paramsLs-hata");
      }
    });
  };

  const title = (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <Typography sx={{ display: "inline" }} variant="subtitle2">
              Müşteri :{" "}
            </Typography>

            <Typography
              sx={{ display: "inline", color: "text.secondary" }}
              variant="body2"
            >
              {notification.customerName + " " + notification.customerSurname}
            </Typography>
          </div>
          <div>
            <Typography sx={{ display: "inline" }} variant="subtitle2">
              Proje :{" "}
            </Typography>

            <Typography
              sx={{ display: "inline", color: "text.secondary" }}
              variant="body2"
            >
              {notification.projectName}
            </Typography>
          </div>
          <div>
            <Typography sx={{ display: "inline" }} variant="subtitle2">
              Not:
            </Typography>
            <Typography
              sx={{ display: "inline", color: "text.secondary" }}
              variant="body2"
            >
              &nbsp; {notification.note}
            </Typography>
          </div>
        </div>
        <div>
          <Checkbox
            checked={notification.status ? true : false}
            disabled={notification.status ? "disabled" : ""}
            onChange={() => handleChangeTask(notification.id)}
          />
        </div>
      </div>
    </>
  );

  return {
    avatar: notification.avatar ? (
      <img alt={notification.title} src={notification.avatar} />
    ) : null,
    title,
    projectName: notification.projectName,
    atayan: notification.userName + " " + notification.userSurname,
    atanan: notification.assignedUserName + " " + notification.assignedUserSurname
  };
}
